<template>
  <div class="userinfo2">
    <b>{{ item.NChart }}</b>
    -
    {{ item.FName }}
  </div>
</template>

<script>
export default {
  props: ["item"],
};
</script>
<style scoped>
.userinfo2 {
  width: 100%;

  text-align: right;
}
</style>
